module.exports = __webpack_public_path__ + "img/71ne.8b3423f4.svg";